import React from 'react';
import { DataSearch } from '@appbaseio/reactivesearch';
import { css } from 'emotion';

const navStyles = css`
	padding: 10px;
	background: #262626;
	width: 100%;
	position: fixed;
	height: 60px;
	z-index: 1;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.logo {
		color: #fafafa;
		font-weight: 500;
		padding: 5px;
	}

	.datasearch {
		width: 40%;
		input {
			background: #f5f5f5;
			border-radius: 2px;
			border: 0;
			&:hover,
			&:focus {
				background: #fafafa;
			}
		}

		@media (max-width: 1024px) {
			width: 55%;
		}
	}
`;

const Navbar = () => (
	<nav className={navStyles}>
		<div className="logo">MovieSearch</div>
		<DataSearch
			componentId="search"
			dataField={[
				'original_title',
				'original_title.autosuggest',
				'original_title.keyword',
				'original_title.search',
			]}
			className="datasearch"
			fieldWeights={[2, 1, 1, 1]}
			fuzziness={0}
			highlight
			URLParams
			highlightField={['original_title']}
			placeholder="Search movies"
		/>
	</nav>
);

export default Navbar;
